'use client';

import React, { useEffect, useState } from 'react';

export default function RGPSReferralBubble() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 300);
    return () => clearTimeout(timer);
  }, []);

  const scrollToEstimate = () => {
    const el = document.getElementById('estimate');
    if (el) el?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div
      className="w-full px-4 sm:px-6 py-6 flex justify-center"
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(-12px)',
        transition: 'opacity 0.6s ease, transform 0.6s ease',
      }}
    >
      <div className="bg-white rounded-3xl shadow-lg border border-teal/20 px-6 py-5 max-w-2xl w-full flex flex-col sm:flex-row items-center gap-4 sm:gap-6">
        {/* Icon */}
        <div className="flex-shrink-0 w-12 h-12 bg-teal-light rounded-full flex items-center justify-center">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#0ABFBC" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 12V22H4V12"/>
            <path d="M22 7H2v5h20V7z"/>
            <path d="M12 22V7"/>
            <path d="M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7z"/>
            <path d="M12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"/>
          </svg>
        </div>

        {/* Text */}
        <div className="flex-1 text-center sm:text-left">
          <p className="text-dark-text font-bold text-base leading-snug mb-1">
            Know Someone Who Needs Their Property Cleaned?
          </p>
          <p className="text-gray-text text-sm mb-1">
            Refer a friend and earn{' '}
            <span className="text-teal font-bold">$20–$500</span>{' '}
            for every successful referral!
          </p>
          <p className="text-gray-text text-xs mb-1">
            The amount you earn depends on the total value of the completed job. Larger jobs earn larger referral rewards.
          </p>
          <p className="text-gray-text text-xs mb-1">
            To claim your referral reward, have the customer{' '}
            <span className="font-semibold text-dark-text">@ your name in the "Additional Details" section</span>{' '}
            when requesting an estimate.
          </p>
          <p className="text-gray-text text-xs italic">
            Referral rewards are paid after the referred customer's job has been successfully completed and paid in full.
          </p>
        </div>

        {/* Button */}
        <button
          onClick={scrollToEstimate}
          className="flex-shrink-0 bg-teal hover:bg-teal-dark text-white font-bold text-sm px-5 py-2.5 rounded-full shadow-teal transition-all hover:scale-105 whitespace-nowrap"
        >
          🎁 Refer Someone
        </button>
      </div>
    </div>
  );
}
